import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { useStrip } from '../hooks/useStrip';

export const Placeholder: React.FC = () => {
  const { xScale, height, onset, offset } = useStrip();
  const ecgDuration = useSelector(roundedDurationSelector);
  const width = useMemo(
    () => xScale(ecgDuration + onset + offset),
    [xScale, ecgDuration, onset, offset],
  );

  return (
    <rect
      className='placeholder'
      width={width}
      height={height}
      fillOpacity={0}
    />
  );
};
